import { VendorManagement } from "~/features/vendor-management/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { RoleGuard } from "~/shared/components/role-guard/role-guard.tsx";
import { VENDOR_MANAGEMENT_ROLES } from "~/shared/constants/page-roles.ts";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const VendorManagementPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxltlVendorManagement");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	if (!isEnabled) {
		return <Construction />;
	}

	if (isInternal) {
		return <VendorManagement />;
	}

	return (
		<RoleGuard allowedRoles={VENDOR_MANAGEMENT_ROLES}>
			<VendorManagement />
		</RoleGuard>
	);
};
